import React, { useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { styled } from "@mui/material/styles";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useNotify from "../utils/useNotify";
import { getAllDrafts15cb } from "../services/httpCalls";
import { useRecoilValue } from "recoil";
import { transactionClicked } from "../store/gloabalState";
import JsFileDownloader from "js-file-downloader";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import TaskIcon from "@mui/icons-material/Task";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
  Table,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import PreviewApproveFifCB from "./PreviewApproveFifCB";
import { DateConvert } from "../utils/dateConverter";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",

  boxShadow: 24,
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: ".5rem",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: ".5rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const DraftsApproval = () => {
  const transactionId = useRecoilValue(transactionClicked);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [docs, setDocs] = useState();
  const fetchtableData = async () => {
    await getAllDrafts15cb(transactionId)
      .then((res) => {
        setDocs(res);
      })
      .catch((err) => {
        console.log(err);
      });
    handleOpen();
  };
  const cols = [
    {
      colName: "File Name",
      colId: "file name",
    },
    {
      colName: "Status",
      colId: "status",
    },
    {
      colName: "Preview and Approve",
      colId: "Approve",
    },
    {
      colName: "Time",
      colId: "time",
    },
  ];
  const extension = (fileName) => {
    return fileName.endsWith("zip");
  };
  return (
    <Box>
      <Box>
        <Button
          startIcon={<TaskIcon />}
          onClick={fetchtableData}
          variant="contained"
        >
          Draft 15CB
        </Button>
      </Box>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            >
              View Files
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              marginBottom: "20px",
              paddingBottom: 2,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            ></Typography>

            <Box p={2}>
              {docs?.length ? (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      maxHeight: "340px",
                    }}
                  >
                    <Table
                      stickyHeader
                      sx={{
                        minWidth: 350,
                        overflowY: "scroll",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          {cols?.map((cols, i) => {
                            return (
                              <StyledTableCell key={i} align="center">
                                {cols.colName}
                              </StyledTableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {docs?.map((value, i) => {
                          let nopreview = extension(value.documentName);

                          let date = new Date(
                            parseInt(value.creationTime)
                          ).toLocaleDateString();
                          let time = new Date(
                            parseInt(value.creationTime)
                          ).toLocaleTimeString();

                          return (
                            <StyledTableRow>
                              <StyledTableCell
                                sx={{
                                  width: "180px",
                                }}
                                align="center"
                              >
                                {value.documentName}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {value.draft15CBStatus === "APPROVED" ? (
                                  <CheckCircleTwoToneIcon
                                    sx={{
                                      color: "green",
                                    }}
                                  />
                                ) : (
                                  <>
                                    {value.draft15CBStatus === "REJECTED" ? (
                                      <CancelTwoToneIcon
                                        sx={{
                                          color: "red",
                                        }}
                                      />
                                    ) : (
                                      <>{value.draft15CBStatus}</>
                                    )}
                                  </>
                                )}
                              </StyledTableCell>
                              {nopreview ? (
                                <StyledTableCell align="center">
                                  No Preview
                                </StyledTableCell>
                              ) : (
                                <StyledTableCell align="center">
                                  <PreviewApproveFifCB
                                    url={value?.documentPath}
                                    docId={value?.id}
                                    status={value?.draft15CBStatus}
                                    closeTable={handleClose}
                                  />
                                </StyledTableCell>
                              )}
                              <StyledTableCell align="center">
                                {
                                  <>
                                    {
                                      <div>
                                        <div>{date}</div>
                                        <div>{time}</div>
                                      </div>
                                    }
                                  </>
                                }
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Box
                  sx={{
                    padding: "3rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <AutoStoriesIcon
                    sx={{
                      fontSize: "100px",
                      color: "#DDE0E4",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      color: "#DDE0E4",
                    }}
                  >
                    No Data
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 3,
                mr: 3,
              }}
            ></Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DraftsApproval;
